import { render } from "./HelpFAQ.vue?vue&type=template&id=dbc0a918&scoped=true"
import script from "./HelpFAQ.vue?vue&type=script&lang=js"
export * from "./HelpFAQ.vue?vue&type=script&lang=js"

import "./HelpFAQ.vue?vue&type=style&index=0&id=dbc0a918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc0a918"]])

export default __exports__